import { AfterViewInit, Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";

declare global {
  interface Window {
    khConfig: any;
  }
}

@Component({
    selector: "app-careers",
    templateUrl: "./careers.component.html",
    styleUrls: ["./careers.component.scss"],
    standalone: false
})
export class CareersComponent implements OnInit, AfterViewInit {
  subHeadlines: string[] = [
    $localize`:@@careers.subheadline1:Your career deserves a 100x pump.`,
    $localize`:@@careers.subheadline2:Where innovators and great minds code, traders win, and the future is minted.`,
    $localize`:@@careers.subheadline3:No suits. No limits. Just crypto and chaos.`,
    $localize`:@@careers.subheadline4:Join the HODLers of innovation.`,
    $localize`:@@careers.subheadline5:Mining talent. Minting futures.`,
    $localize`:@@careers.subheadline6:Where blockchain meets your career breakthrough.`,
    $localize`:@@careers.subheadline7:Join the team powering the future of finance.`,
    $localize`:@@careers.subheadline8:Your skills. Our crypto revolution.`,
    $localize`:@@careers.subheadline9:Build the exchange. Shape the future.`,
    $localize`:@@careers.subheadline10:Trade in your old job for the next big thing.`,
  ];

  subHeadline!: string;

  ngOnInit(): void {
    this.pickRandomSubheadline();
  }

  ngAfterViewInit(): void {
    const scriptKey = environment.kekaCareers.key;
    window.khConfig = {
      identifier: scriptKey,
      domain: "https://dcx.keka.com/careers/",
      targetContainer: "#khembedjobs",
    };

    const script = document.createElement("script");
    script.src = "https://dcx.keka.com/careers/api/embedjobs/js/" + scriptKey;
    script.defer = true;
    document.body.appendChild(script);
  }

  pickRandomSubheadline(): void {
    const randomIndex = Math.floor(Math.random() * this.subHeadlines.length);
    this.subHeadline = this.subHeadlines[randomIndex];
  }

  scrollToSection(sectionId: string) {
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
}
